import SBEditable from "../../../components/sbEditable/sbEditable"
import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer"
import { ParagraphAlignmentKeyToClassName, TextColorKeyToClassName } from "../../../helpers/datasourceHelpers"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

import styles from "./richText.module.scss"

/// Blok:richtext
// headline:text
// headline_color:text
// headline_alignment:left,center,right
// content:richtext
// content_color:text
// content_alignment:left,center,right
// anchor:text
///
function RichText({ blok }) {
  return (
    <SBEditable blok={blok} withId={blok.anchor} withClass={ArticlePanelOptionsToClasses(blok)}>
      {blok.headline ? (
        <h2 
          className={`richtext-headline ${ParagraphAlignmentKeyToClassName(blok.headline_alignment)} ${TextColorKeyToClassName(blok.headline_color)}`}>
            {blok.headline}
        </h2>
      ) : null}
      {blok.content ? (
        <div className={`richtext ${styles.richtext} ${ParagraphAlignmentKeyToClassName(blok.content_alignment)} ${TextColorKeyToClassName(blok.content_color)}`}>
          <RichTextWithBlokRenderer document={blok.content} />
        </div>
      ) : null}
    </SBEditable>
  )
}

export default RichText